//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { date } from "quasar";
import { mapActions, mapState } from "vuex";
import router from "../../router";
// import { parse } from "vue-currency-input";
import purchaseOrderItems from "./components/PurchaseOrderItems";
import dimensions from "./components/Dimensions";
import numericclean from "@/components/numericClean";
import logger from "@/utils/logger";

export default {
  data() {
    return {
      isLoadingOrder: false,
      pagination: {
        rowsPerPage: 10,
      },
      supplierStatus: {
        Inactive: 50001
      },
      changeStatusText: "",
      refreshChipsKey: 0,
      orderStatus: "",
      orderNumber: "",
      savedisabled: false,
      sendEmailWithOrder: true,
      customers: [],
      Currencies: [],
      orderExchangeRate: {},
      productCategoryLinks: [],
      supplierDiscounts: [],
      totalText: "Totalt",
      quantityText: "Antall",
      totalValue: "0",
      totalValueNative: "0",
      orderitemsQuantity: 0,
      showAdjustOrder: false,
      adjustTotalSumText: "",
      VatTypes: [],
      FilterVatTypes: [],
      Suppliers: [],
      FilterSuppliers: [],
      supplierName: "",
      SupplierEmails: [],
      FilterSupplierEmails: [],
      order: {},
      headerTitle: "",
      showSaveDialog: false,
      showChangeOrderStatusDialog: false,
      showEndOrderDialog: false,
      pendingStatusTo: 0,
      tab: "details",
      tabSupplier: "supplierTab",
      id: 0,
      warehouseOptions: [],
      selectedWarehouse: {},
      rowCount: 10,
      existingOrder: false,
      dense: true,
      currencyDate: null,
      nonCreditedTransactions: [],
      selectedTransactions: [],
      defaultCountry: null,
      defaultIncludePriceInReport: null,      
      adjustColumns: [
        {
          name: "id",
          align: "left",
          label: "",
          field: "id",
          style: "width: 0px",
          sortable: true,
        },
        {
          name: "productNumber",
          align: "left",
          label: this.$t("order.productNumber"),
          field: "productNumber",
          style: "width: 200px",
          sortable: true,
        },
        {
          name: "productName",
          align: "left",
          label: this.$t("order.productName"),
          field: "productName",
          sortable: true,
        },
        {
          name: "productType",
          align: "left",
          label: this.$t("order.productType"),
          field: "productType",
          sortable: true,
        },
        {
          name: "locationName",
          align: "left",
          label: this.$t("order.locationName"),
          field: "locationName",
          sortable: true,
        },
        {
          name: "quantity",

          label: this.$t("order.quantity"),
          field: "numberOfItems",
          style: "width: 100px",
          sortable: true,
        },
        {
          name: "discountPercentage",
          align: "right",
          label: "Rabatt %",
          field: "discountPercentage",
          style: "width: 100px",
          sortable: true,
        },
        {
          name: "price",

          label: this.$t("purchaseOrder.price"),
          field: "price",
          style: "width: 100px",
          sortable: true,
        },
      ],
    };
  },

  components: {
    purchaseOrderItems,
    dimensions,
    numericclean,
  },

  computed: {
    ...mapState("main", ["currencies", "suppliers", "company", "companySettings"]),

    sumSelectedTransactions() {
      if (!this.selectedTransactions || this.selectedTransactions.length < 1)
        return "";

      var totalSum = 0.0;
      this.selectedTransactions.forEach((element) => {
        var sumItem = element.numberOfItems * element.price;
        totalSum += sumItem;
      });
      return totalSum;
    },
  },
  watch: {
    selectedWarehouse: {
      async handler(newVal, oldVal) {
        if (this.isLoadingOrder) {
          return;
        }

        if (newVal && oldVal && 
            newVal.label === "Overstyr" && 
            oldVal.label === "Overstyr") {
          return;
        }

        if (newVal) {
          if (newVal.label === "Overstyr") {
            this.order.warehouseId = null;
            this.order.isAddressOverride = true;
            if (oldVal && oldVal.value !== null) {
              this.order.deliveryAddressLine1 = "";
              this.order.deliveryAddressLine2 = "";
              this.order.deliveryAddressLine3 = "";
              this.order.deliveryPostalCode = "";
              this.order.deliveryCity = "";
              this.order.deliveryCountry = await this.getDefaultCountry();
            }
          } else {
            this.order.warehouseId = newVal.value;
            this.order.isAddressOverride = false;
            this.order.deliveryAddressLine1 = newVal.address;
            this.order.deliveryAddressLine2 = "";
            this.order.deliveryAddressLine3 = "";
            this.order.deliveryPostalCode = newVal.postCode;
            this.order.deliveryCity = newVal.city;
            this.order.deliveryCountry = await this.getDefaultCountry();
          }
        }
      },
      deep: false
    }
  },
  methods: {
    async refresh() {
      const notif = this.$q.notify({
        type: "ongoing",
        message: "Laster data...",
      });

      this.id = this.$route.params.id;
      if (this.id > 0) {
        await this.fetchPurchase(this.id);
        this.existingOrder = true;
      }

      setTimeout(() => {
        notif();
      }, 500);
    },
    setModel(val) {
      this.order.supplierEmail = val;
    },

    async saveAdjustment() {
      if (!this.selectedTransactions || this.selectedTransactions.length < 1) {
        this.$q.notify({
          type: "negative",
          message: this.$t("purchaseOrder.noTransactionsSelected"),
        });
        return;
      }
      const notif = this.$q.notify({
        message: this.$t("purchaseOrder.adjustingTransactions") + "...",
        timeout: 0,
        spinner: true,
      });

      var tempDate = this.currencyDate.split("-");
      var dto = {
        transactions: this.selectedTransactions,
        currencyDate: tempDate[2] + "-" + tempDate[1] + "-" + tempDate[0],
      };

      this.adjustTransactions(dto).then(() => {
        this.fetchPurchase(this.id);
        notif();
      });
    },

    getEmailFromSupplierFilter(val, update) {
      if (!this.SupplierEmails) {
        update();
        return;
      }
      update(() => {
        this.SupplierEmails = this.FilterSupplierEmails.filter(
          (w) => w.toLowerCase().indexOf(val.toLowerCase()) > -1
        );
      });
    },

    getSupplierFilter(val, update) {
      if (!this.Suppliers) {
        update();
        return;
      }
      update(() => {
        this.Suppliers = this.FilterSuppliers.filter(
          (w) =>
            w.name.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
            w.supplierNumber
              .toString()
              .toLowerCase()
              .indexOf(val.toLowerCase()) > -1
        );
      });
    },

    async updateSumary() {
      const currency = this.Currencies.find(
        (x) => x.id === this.order.currencyCodeId
      );
      this.totalText =
        this.$t("purchaseOrder.total") + " (" + currency.code + ")";
      var totValue = parseFloat(0);
      this.orderitemsQuantity = 0;
      this.order.orderItems.forEach((element) => {
        if (element.productId) {
          var price = element.price;
          const qtySum = element.numberOfItems * price;
          const dicsount = (qtySum * element.discountPercentage) / 100;
          totValue += qtySum - dicsount;
          this.orderitemsQuantity += element.numberOfItems;
        }
      });
      // Oppdater valuta sum
      this.totalValue = new Intl.NumberFormat("no-NO", {
        minimumFractionDigits: 2,
      }).format(totValue);

      // Oppdater sum i lokal valuta
      if (this.orderExchangeRate.id != this.order.currencyCodeId) {
        this.orderExchangeRate = await this.getExchangeRate(
          this.order.currencyCodeId
        );
      }
      if (this.orderExchangeRate)
        if (this.orderExchangeRate.exchangeRate) {
          if (
            this.orderExchangeRate.exchangeRate != 1 &&
            this.orderExchangeRate.exchangeRate != 0
          ) {
            totValue = totValue * this.orderExchangeRate.exchangeRate;
          }
          this.totalValueNative = new Intl.NumberFormat("no-NO", {
            minimumFractionDigits: 2,
          }).format(Math.round(totValue * 100) / 100);
        } else {
          this.totalValueNative = "";
        }
    },

    async orderDateChanged() {
      this.order.orderDate = this.autoCompleteDate(this.order.orderDate);
    },
    async deliveryDateChanged() {
      this.order.deliveryDate = this.autoCompleteDate(this.order.deliveryDate);
    },
    async currencyDateChanged() {
      this.currencyDate = this.autoCompleteDate(this.currencyDate);
    },

    autoCompleteDate(strDate) {
      if (strDate.length > 0 && strDate.length < 7) {
        if (isNaN(parseInt(strDate))) return "";
        try {
          if (strDate.length < 6) {
            let today = new Date();
            if (strDate.length == 1)
              strDate = "0" + strDate + date.formatDate(today, "MMYY");
            else if (strDate.length == 2)
              strDate = strDate + date.formatDate(today, "MMYY");
            else if (strDate.length == 3) {
              strDate = strDate.substring(0, 2) + "0" + strDate.substring(2, 3);
              strDate = strDate + date.formatDate(today, "YY");
            } else if (strDate.length == 4)
              strDate = strDate + date.formatDate(today, "YY");
            else if (strDate.length == 5) {
              strDate = strDate.substring(0, 4);
              strDate = strDate + date.formatDate(today, "YY");
            }
          }

          let newDate = date.extractDate(strDate, "DDMMYY");
          return date.formatDate(newDate, "DD-MM-YYYY");
        } catch (error) {
          return "";
        }
      }
      return strDate;
    },

    supplierValueChanged(value) {
      this.order.supplierEmail = "";

      if (value) {
        var selectedSupplier = this.Suppliers.find((x) => x.id == value);
        this.setFieldsBasedonSupplier(selectedSupplier)

        if (this.order.orderItems && this.order.supplierId > 0) {
          var anyChanged = false;
          this.order.orderItems.forEach((element) => {
            if (
              (element.discountPercentage == null ||
                element.discountPercentage == 0) &&
              element.productId > 0
            ) {
              var productlinks = this.productCategoryLinks.filter(
                (x) => x.productID == element.productId
              );
              if (productlinks.length > 0) {
                var discounts = this.supplierDiscounts.filter(
                  (x) =>
                    x.supplierId == this.order.supplierId &&
                    productlinks.filter(
                      (y) => y.productCategoryID == x.productCategoryId
                    )
                );
                if (discounts.length > 1) {
                  discounts.sort((a, b) => {
                    return b.discount - a.discount;
                  });
                }
                if (discounts.length > 0) {
                  element.discountPercentage = discounts[0].discount;
                  anyChanged = true;
                }
              }
            }
          });
          if (anyChanged) {
            this.calculateSum();
            this.updateSumary();
          }
        }
      }
    },

    setFieldsBasedonSupplier(selectedSupplier) {
      if(!selectedSupplier) {
        return;
      }

      this.setEmailBasedonSupplier(selectedSupplier)

      this.supplierName = selectedSupplier.name;

      var currency = selectedSupplier.currencyCodeID;
      if (currency) {
        this.order.currencyCodeId = currency;
      }
    },

    getSupplierEmails(value) {
      this.SupplierEmails = this.Suppliers.find((x) => x.id == value).emails;
      this.FilterSupplierEmails = this.Suppliers.find(
        (x) => x.id == value
      ).emails;
      this.supplierName = this.Suppliers.find((x) => x.id == value).name;
    },

    setEmailBasedonSupplier(selectedSupplier) {
      this.SupplierEmails = [];
      this.FilterSupplierEmails = [];
            
      for(var i = 0; i < selectedSupplier.contacts.length; i++) {
        if(selectedSupplier.contacts[i].emailAddress) {    
          this.SupplierEmails.push(selectedSupplier.contacts[i].emailAddress);
          this.FilterSupplierEmails.push(selectedSupplier.contacts[i].emailAddress);
        }
      }

      if(this.SupplierEmails.length == 0) {
        this.SupplierEmails = selectedSupplier.emails;
        this.FilterSupplierEmails = selectedSupplier.emails;
      }

      if(selectedSupplier.defaultContactId != null) {
        this.order.supplierEmail = selectedSupplier.contacts.find((x) => x.id == selectedSupplier.defaultContactId).emailAddress;
      }
      else if(selectedSupplier.contacts.length != 0){
        this.order.supplierEmail = selectedSupplier.contacts[0].emailAddress;
      }
      else {
        this.order.supplierEmail = this.FilterSupplierEmails[0];
      }        
    },

    async newPurchase() {
      this.refreshChipsKey++;
      this.order.suppliersOrderNo = null;
      this.headerTitle = "Innkjøpsordre";
      this.order = {
        suppliersOrderNo: "",
        purchaseOrderStatusId: 100,
        currencyCodeId: 1,
        localization: "no",
        tax: "",
        label: "",
        yourReference: "",
        ourReference: "",
        deliveryTerms: "",
        deliveryMethod: "",
        receiver: "",
        supplierEmail: "",
        comment: "",
        orderDate: date.formatDate(Date.now(), "DD-MM-YYYY"),
        orderItems: [],
        includePriceInReport: this.defaultIncludePriceInReport,
        warehouseId: null,
        isAddressOverride: false,
        deliveryAddressLine1: "",
        deliveryAddressLine2: "",
        deliveryAddressLine3: "",
        deliveryCity: "",
        deliveryPostalCode: "",
        deliveryCountry: await this.getDefaultCountry(),
        deliveryName: "" 
      };

      if (this.company.addressLine1)
        this.order.deliveryAddressLine1 = this.company.addressLine1;
      if (this.company.addressLine2)
        this.order.deliveryAddressLine2 = this.company.addressLine2;
      if (this.company.addressLine3)
        this.order.deliveryAddressLine3 = this.company.addressLine3;
      if (this.company.city) 
        this.order.deliveryCity = this.company.city;
      if (this.company.postalCode)
        this.order.deliveryPostalCode = this.company.postalCode;

      var countries = await this.getCountries();

      if(countries.length != 0 && countries.find(x => x.countryCode.toLowerCase() == this.company.countryCode) != null) {
        this.order.deliveryCountry = countries.find(x => x.countryCode.toLowerCase() == this.company.countryCode).name;
      }
      else {
        this.order.deliveryCountry = "Norge";
      }
    },
    async delPurchaseOrder() {
      if (this.order.purchaseOrderStatusId < 400) {
        try {
          await this.deletePurchaseOrder(this.id);

          this.$q.notify({
            type: "positive",
            message: this.$t("common.deleteMessage"),
          });
          router.push({
            name: "Purchases",
          });
        } catch (error) {
          logger.log("error", error);
          this.$q.notify({
            type: "negative",
            message: `${this.$t(
              "common.errorSave"
            )}. ${this.$utils.GetErrorMessage(error)}`,
          });
        }
      } else {
        this.$q.notify({
          type: "negative",
          message:
            this.$t("common.errorSave") +
            " " +
            this.$t("purchaseOrder.deleteDenied"),
        });
      }
    },

    async showAdjustOrderClick() {
      if (!this.order || !this.order.orderItems) return [];
   
      this.currencyDate = date.formatDate(Date.now(), "DD-MM-YYYY");
      this.nonCreditedTransactions = this.order.orderItems
        .map((item) =>
          item.transactions.map((transaction) => ({ ...transaction }))
        )
        .flat();
     

      // this.nonCreditedTransactions = this.nonCreditedTransactions.filter(
      //   (item) =>
      //     !item.jorunalEntryCredited &&
      //     !item.adjustedPrice &&
      //     item.journalEntryNumber
      // );

      this.nonCreditedTransactions = this.nonCreditedTransactions.filter(
        (item) => !item.adjustedPrice
      );
      this.selectedTransactions = this.nonCreditedTransactions;

     
      this.nonCreditedTransactions.forEach((element) => {
        if (element.discountPercentage > 0) {
          var discount = (element.discountPercentage * element.price) / 100;
          element.price = element.price - discount;
        }
      });
  
      const currency = this.Currencies.find(
        (x) => x.id === this.order.currencyCodeId
      );
      this.adjustTotalSumText =
        this.$t("purchaseOrder.total") + " (" + currency.code + ")";

      this.showAdjustOrder = true;
    },

    async createDraft() {
      if (!this.order.supplierId) {
        this.$q.notify({
          type: "negative",
          message: this.$t("purchaseOrder.messageMissingSupplier"),
        });
        return;
      }

      var items = await this.getSuggestedOrderItemsBySupplier(
        this.order.supplierId
      );

      this.order.orderItems = items;

      this.updateSumary();
    },
    calculateSum() {
      if (this.order.orderItems) {
        this.order.orderItems.forEach((element) => {
          if (element.productId) {
            var price = element.price;
            const qtySum = element.numberOfItems * price;

            const dicsount = (qtySum * element.discountPercentage) / 100;
            const total = qtySum - dicsount;
            element.sum = new Intl.NumberFormat("no-NO").format(total);
          }
        });
      }
    },

    async purchaseOrderPdf() {
      this.save();
      const notif = this.$q.notify({
        message: this.$t("common.downloading"),
        timeout: 0,
        spinner: true,
      });

      this.getPurchaseOrderReport(this.id).then((res) => {
        notif();

        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "PurchaseOrder.pdf");
        document.body.appendChild(link);
        link.click();
      });
    },

    async sendOrder() {
      if (!this.order.supplierEmail) {
        this.$q.notify({
          type: "negative",
          message: this.$t("purchaseOrder.messageMissingSupplierEmail"),
        });
        return;
      }
      const notif = this.$q.notify({
        message: this.$t("purchaseOrder.sendingOrder") + "...",
        timeout: 0,
        spinner: true,
      });
      this.save();
      this.sendPurchaseOrder(this.id).then((res) => {
        notif();
        this.mapOrder(res);
      });
    },

    async saveOrder(){
      if (!this.order.supplierId) {
        this.$q.notify({
          type: "negative",
          message: this.$t("purchaseOrder.messageMissingSupplier"),
        });
        return;
      }

      if (this.order.isAddressOverride === true) {
        if (!this.order.deliveryAddressLine1 || !this.order.deliveryPostalCode || 
            !this.order.deliveryCity || !this.order.deliveryCountry) {
          this.$q.notify({
            type: "negative",
            message: "Ved overstyr må leveringsadresse, postkode, poststed og land fylles ut",
          });
          return;
        }
      }

      this.savedisabled = true;
      try {
        var lines = [];
        var orderDto = {};
        orderDto.purchaseOrderStatusId = this.order.purchaseOrderStatusId;
        orderDto.currencyCodeId = this.order.currencyCodeId;
        orderDto.supplierId = this.order.supplierId;
        orderDto.supplierName = this.supplierName;
        orderDto.supplierEmail = this.order.supplierEmail;
        orderDto.localization = this.order.localization;
        orderDto.warehouseId = this.order.warehouseId;
        orderDto.isAddressOverride = this.order.isAddressOverride;
        orderDto.invoiceDate = this.order.invoiceDate;
        orderDto.invoiceNumber = this.order.invoiceNumber;

        orderDto.supplierOrderNumber = this.order.supplierOrderNumber;
        orderDto.comment = this.order.comment;
        orderDto.dimension1Id = this.order.dimension1Id;
        orderDto.dimension2Id = this.order.dimension2Id;
        orderDto.dimension3Id = this.order.dimension3Id;
        orderDto.dimension4Id = this.order.dimension4Id;
        orderDto.dimension5Id = this.order.dimension5Id;
        orderDto.dimension6Id = this.order.dimension6Id;
        orderDto.dimension7Id = this.order.dimension7Id;
        orderDto.dimension8Id = this.order.dimension8Id;
        orderDto.dimension9Id = this.order.dimension9Id;
        orderDto.deliveryAddressLine1 = this.order.deliveryAddressLine1;
        orderDto.deliveryAddressLine2 = this.order.deliveryAddressLine2;
        orderDto.deliveryAddressLine3 = this.order.deliveryAddressLine3;
        orderDto.deliveryCity = this.order.deliveryCity;
        orderDto.deliveryCountry = this.order.deliveryCountry;
        orderDto.deliveryCountryCode = this.order.deliveryCountryCode;
        orderDto.deliveryPostalCode = this.order.deliveryPostalCode;
        orderDto.deliveryName = this.order.deliveryName;
        orderDto.yourReference = this.order.yourReference;
        orderDto.ourReference = this.order.ourReference;
        orderDto.label = this.order.label;
        orderDto.purchaser = this.order.purchaser;
        orderDto.includePriceInReport = this.order.includePriceInReport;

        var tempDate;
        if (this.order.orderDate) {
          tempDate = this.order.orderDate.split("-");
          orderDto.orderDate = tempDate[2] + "-" + tempDate[1] + "-" + tempDate[0];
        }

        if (this.order.invoiceDate) {
          tempDate = this.order.invoiceDate.split("-");
          orderDto.invoiceDate =
            tempDate[2] + "-" + tempDate[1] + "-" + tempDate[0];
        }

        if (this.order.deliveryDate) {
          tempDate = this.order.deliveryDate.split("-");
          orderDto.deliveryDate =
            tempDate[2] + "-" + tempDate[1] + "-" + tempDate[0];
        }

        for (let i = 0; i < this.order.orderItems.length; i++)  {
          const element = this.order.orderItems[i];
          var line = {};

          if(element.productId == null) {
            this.$q.notify({
              type: "negative",
              message: "Ordrelinje: " + (i + 1) + " mangler produkt",
            });

            this.savedisabled = false;
            return;
          }

          if (this.id != 0) {
            line["id"] = element.id;
            line["purchaseOrderId"] = element.purchaseOrderId;
          }

          if(element.customerOrderItem)
            line["customerOrderItem"] = element.customerOrderItem

          if(element.customerOrderItemId)
            line["customerOrderItemId"] = element.customerOrderItemId

          line["productId"] = element.productId;
          line["itemText"] = element.itemText;
          line["numberOfItems"] = element.numberOfItems;
          line["discountPercentage"] = element.discountPercentage;
          line["vatTypeId"] = element.vatTypeId;
          line["price"] = element.price;
          line["warehouseId"] = element.warehouseId;
          line["isAddressOverride"] = element.isAddressOverride;

          line["dimension1Id"] = element.dimension1Id;
          line["dimension2Id"] = element.dimension2Id;
          line["dimension3Id"] = element.dimension3Id;
          line["dimension4Id"] = element.dimension4Id;
          line["dimension5Id"] = element.dimension5Id;
          line["dimension6Id"] = element.dimension6Id;
          line["dimension7Id"] = element.dimension7Id;
          line["dimension8Id"] = element.dimension8Id;
          line["dimension9Id"] = element.dimension9Id;
          if (element.deliveryDate) {
            tempDate = element.deliveryDate.split("-");
            line["deliveryDate"] =
              tempDate[2] + "-" + tempDate[1] + "-" + tempDate[0];
          }

          lines.push(line);
        }

        orderDto.orderItems = lines;

        if (this.id == 0) {
          var createdDto = await this.postPurchaseOrder(orderDto);
          this.$q.notify({
            type: "positive",
            message: this.$t("common.saveOk"),
          });
          this.id = createdDto.id;
          this.internalID = createdDto.id;
          this.mapOrder(createdDto);
        } else {
          var updatedDto = await this.putPurchaseOrder({
            id: this.id,
            purchaseDto: orderDto,
          });
          this.$q.notify({
            type: "positive",
            message: this.$t("common.saveOk"),
          });
          this.mapOrder(updatedDto);
        }
      } catch (error) {
        logger.log("error", error);
        this.$q.notify({
          type: "negative",
          message: `${this.$t(
            "common.errorSave"
          )}. ${this.$utils.GetErrorMessage(error)}`,
        });
      }
      this.savedisabled = false;
    },

    async saveAndDelete(){
      await this.saveOrder();
      await this.delPurchaseOrder();

    },

    async save() {
      if(this.order.orderItems.length == 0){
        this.showSaveDialog = true;
      }
      else{
        await this.saveOrder();
      }

    },
    async fetchPurchase(id) {
      const data = await this.getPurchaseOrder(id);

      this.mapOrder(data);
    },

    async mapOrder(data) {
      this.isLoadingOrder = true;
      this.order = data;
      this.order.orderDate = date.formatDate(data.orderDate, "DD-MM-YYYY");
      this.orderNumber = this.order.orderNumber.toString();
      this.orderStatus = this.$t(
        "purchaseOrder.status-" + this.order.purchaseOrderStatusId
      );

      this.headerTitle =
        this.$t("headers.purchaseOrder") +
        " " +
        this.orderNumber +
        " - " +
        this.orderStatus;
      this.refreshChipsKey++;
      this.orderExchangeRate = await this.getExchangeRate(
        this.order.currencyCodeId
      );
      this.order.deliveryDate = date.formatDate(
        data.deliveryDate,
        "DD-MM-YYYY"
      );
      this.order.orderItems.forEach((element) => {
        element.deliveryDate = date.formatDate(
          element.deliveryDate,
          "DD-MM-YYYY"
        );
        element.dirty = 0;
      });
      if (this.order.supplierId) {
        this.getSupplierEmails(this.order.supplierId);
      }
      this.calculateSum();
      this.updateSumary();

      await this.getWarehouses();
    
      this.isLoadingOrder = false;
    },

    async changeOrderStatus() {
      try {
        if(this.pendingStatusTo == 0) {
          this.$q.notify({
            type: "negative",
            message: "Feil ved endring av status"
          });
          return;
        }

        if(this.order.id == 0 || this.order.id == undefined) {
          this.$q.notify({
            type: "negative",
            message: "Ordre er ikke opprettet"
          });
          return;
        }

        for (let i = 0; i < this.order.orderItems.length; i++)  {
          const element = this.order.orderItems[i];

          if(element.productId == null) {
            this.$q.notify({
              type: "negative",
              message: "Ordrelinje: " + (i + 1) + " mangler produkt",
            });

            this.savedisabled = false;
            return;
          }
        }

        const notif = this.$q.notify({
          message: "Endrer status...",
          timeout: 0,
          spinner: true,
        });

        var dto  = {
          id: this.id,
          toStatus: this.pendingStatusTo
        }
        
        await this.save();

        var res = await this.ChangePurchaseOrderStatus(dto);
        await this.mapOrder(res);
        await notif();
        
        this.pendingStatusTo = 0;
        this.refreshChipsKey++;
      }
      catch(error) {
        this.$q.notify({
          type: "error",
          message: error
        });
      }
    },

    checkStatusColor(key) {
      var status = this.order.purchaseOrderStatusId;

      if(key == status) {
        return "chip-active-notClickable";
      }

      if((key < status) && status > 300) {
        return "chip-active-notClickable";
      }
       
      if(key < status && key < 300) {
        return "chip-active"
      }
     
      if((key > status && key < 400) || (key == 700 && status >= 400)) {
        return "chip-neutral"
      }

      return "chip-disabled";
    },

    
    checkStatusRules(key) {
      var status = this.order.purchaseOrderStatusId;

      if(key == status) {
        return false;
      }

      if((key < status) && status > 300) {
        return false;
      }

      if((key > status && key < 400) || (key == 700 && status >= 400)) {
        return true
      }
       
      if((key < status && key < 300) || (key == 700 && status >= 400)) {
        return true
      }
     
      if((key > status && key < 400)) {
        return false
      }

      return false;
    },

    openChangeStatusPopup(status, text) {
      if(status == 300 && (this.order.supplierOrderNumber == null || this.order.supplierOrderNumber == "")) {
        this.$q.notify({
          type: "warning",
          message: "Mangler leverandørens ordrenummer"
        });

        return
      }

      this.changeStatusText = text;

      this.showChangeOrderStatusDialog = true;
      this.pendingStatusTo = status;
    },

    openEndOrderPopup() {
      this.pendingStatusTo = 700;
      this.showEndOrderDialog = true;
    },

    async getWarehouses() {
      var warehouses = await this.getWarehouse();

      if(warehouses.length > 0) {
        warehouses.sort((a, b) => {
          if (a.priority == null && b.priority == null) return 0;
          if (a.priority == null) return 1;
          if (b.priority == null) return -1; 
          return a.priority - b.priority; 
        });
      }

      this.warehouseOptions = [];

      for(var i = 0; i < warehouses.length; i++) {
        this.warehouseOptions.push({
          label: warehouses[i].warehouseName,
          value: warehouses[i].id,
          address: warehouses[i].streetName || "",
          postCode: warehouses[i].postCode || "",
          city: warehouses[i].city || "",
          hasAddress: !!warehouses[i].streetName && !!warehouses[i].postCode && !!warehouses[i].city
        });
      }

      this.warehouseOptions.push({
        label: "Overstyr",
        value: null,
        address: "",
        postCode: "",
        city: "",
        hasAddress: true
      });

      const overrideOption = this.warehouseOptions.find(x => x.label === "Overstyr");
      if (this.order.isAddressOverride) {
        this.selectedWarehouse = overrideOption;
        return;
      }

      if (this.order.warehouseId) {
        this.selectedWarehouse = this.warehouseOptions.find(x => x.value === this.order.warehouseId);
        return;
      }

      if (this.id === 0 && this.warehouseOptions.length > 1) {
        const firstValidWarehouse = this.warehouseOptions.find(x => x.value !== null && x.hasAddress);
        
        if (firstValidWarehouse) {
          this.selectedWarehouse = firstValidWarehouse;
          this.order.warehouseId = firstValidWarehouse.value;
          this.order.isAddressOverride = false;
          this.order.deliveryAddressLine1 = firstValidWarehouse.address;
          this.order.deliveryPostalCode = firstValidWarehouse.postCode;
          this.order.deliveryCity = firstValidWarehouse.city;
          return;
        }
      }

      this.selectedWarehouse = overrideOption;
      this.order.isAddressOverride = true;
      this.order.warehouseId = null;
    },

    async getDefaultCountry() {
      if (!this.defaultCountry) {
        const countries = await this.getCountries();
        
        if (countries.length !== 0 && this.company.countryCode) {
          const companyCountry = countries.find(x => 
            x.countryCode.toLowerCase() === this.company.countryCode.toLowerCase()
          );
          
          this.defaultCountry = companyCountry ? companyCountry.name : "Norge";
        } else {
          this.defaultCountry = "Norge";
        }
      }
      
      return this.defaultCountry;
    },

    ...mapActions("main", [
      "getPurchaseOrder",
      "putPurchaseOrder",
      "postPurchaseOrder",
      "deletePurchaseOrder",
      "getSuggestedOrderItemsBySupplier",
      "getExchangeRate",
      "getPurchaseOrderReport",
      "sendPurchaseOrder",
      "ChangePurchaseOrderStatus",
      "adjustTransactions",
      "getProductCategoryLinks",
      "getSupplierDiscounts",
      "getWarehouse",
      "getCountries"
    ]),
  },
  async created() {
    // GET request using fetch with error handling
    this.id = this.$route.params.id;
    this.Currencies = this.currencies;
    this.Suppliers = this.suppliers.filter(x => x.statusCode != this.supplierStatus.Inactive);
    this.FilterSuppliers = this.suppliers.filter(x => x.statusCode != this.supplierStatus.Inactive);
    this.productCategoryLinks = await this.getProductCategoryLinks();
    this.supplierDiscounts = await this.getSupplierDiscounts();    
    
    this.defaultIncludePriceInReport = this.companySettings.find(setting => setting.settingName === "defaultIncludePriceInReport")?.boolValue ?? false;
    

    if (this.id > 0) {
      await this.fetchPurchase(this.id);
      this.existingOrder = true;
    } else {
      await this.newPurchase();
    }

    await this.getWarehouses();
  },
};
